
import { TableCell, TableRow } from "@/components/ui/table";
import { Star } from "lucide-react";

interface RatingRowProps {
  rating: number;
  description: string;
  isGreen?: boolean;
}

const RatingRow = ({ rating, description, isGreen = false }: RatingRowProps) => {
  // Create an array filled with the number of stars matching the rating
  const stars = Array(rating).fill(0);
  
  // Determine star color based on rating or if explicitly set to green
  const getStarColor = () => {
    if (isGreen) return "fill-green-500 text-green-500";
    
    switch (rating) {
      case 1: return "fill-red-500 text-red-500";
      case 2: return "fill-orange-500 text-orange-500";
      case 3: return "fill-yellow-400 text-yellow-400";
      case 4: return "fill-yellow-400 text-yellow-400";
      case 5: return "fill-yellow-400 text-yellow-400";
      default: return "fill-yellow-400 text-yellow-400";
    }
  };
  
  return (
    <TableRow>
      <TableCell className="py-2 pr-2 w-24">
        <div className="flex justify-end">
          {stars.map((_, i) => (
            <Star key={i} className={`h-4 w-4 ${getStarColor()}`} />
          ))}
        </div>
      </TableCell>
      <TableCell className="py-2 pl-2">
        <span>{description}</span>
      </TableCell>
    </TableRow>
  );
};

export default RatingRow;
